"use client";
import React, { useContext } from "react";
import ToolTip from "@stadium/ui/src/components/tooltip/tooltip";
import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";

import shipsStadiumImg from "@stadium/ui/src/assets/images/ships-from-stadium.svg";
import stadiumNewBoxImg from "@stadium/ui/src/assets/images/stadium-new-box.png";
import stadiumNewBoxImgMobile from "@stadium/ui/src/assets/images/stadium-new-box-mobile.png";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import styles from "./main.module.scss";

const StadiumShippedTooltip = ({
  children,
  asResponsiveModal = false,
  withHeading = false,
  contentWrapperClassName = "",
}) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const renderContent = () => (
    <>
      <div className={styles.stadiumNewBoxImg}>
        <Multimedia
          type="image"
          src={isMobileDevice ? stadiumNewBoxImgMobile : stadiumNewBoxImg}
          isNextImage={false}
        />
      </div>
      <div className={styles.tipHeading}>Ships from stadium warehouse</div>
      <div className={styles.tipText}>
        Our team puts in a lot of effort to ensure that your unboxing experience is exceptional.
      </div>
    </>
  );

  const renderHeading = () => {
    if (!withHeading) return null;
    return (
      <span className={styles.tooltipCustomHeading}>
        <Multimedia
          type="image"
          src={shipsStadiumImg}
          height={16}
          isNextImage={false}
        />
        Ships from Stadium Warehouse
      </span>
    );
  };

  return (
    <ToolTip
      containerClass={styles.toolTipWrapper}
      heading={renderHeading()}
      content={renderContent()}
      isLightTheme
      placement="top-start"
      arrow={true}
      asResponsiveModal={asResponsiveModal}
      disableOnResponsive={!asResponsiveModal}
    >
      <div className={contentWrapperClassName}>
        <Multimedia
          type="image"
          src={shipsStadiumImg}
          height={16}
          isNextImage={false}
          className={styles.qualityImg}
        />
        {children}
      </div>
    </ToolTip>
  );
};

export default StadiumShippedTooltip;
